import React, { useEffect, useState } from 'react';

// images
import moon from '../assets/images/moon.png';
import logo from '../assets/images/logos/logo-icon.svg';
import bookWorld from '../assets/images/book-world-m.svg';
import flower from '../assets/images/flower.svg';
import books from '../assets/images/books.svg';
import gear from '../assets/images/gear.svg';
import user from '../assets/images/user-girl.svg';

// components
import NavBar from './NavBar';
import SideBar from './SideBar';

const PageLayout = ({ children, headerText, type = 'default', underText, image, text }: { children: React.ReactNode, headerText?: string, type?: string, underText?: string | React.ReactNode, image?: string, text?: string }) => {
    const [open, setOpen] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false)
    const getImage = () => {
        switch (type) {
            case 'default':
                return moon;
            case 'light':
                return bookWorld;
            case 'stats':
                return bookWorld;
            case 'dark':
                return logo;
            case 'flower':
                return flower;
            case 'books':
                return books;
            case 'gear': 
                return gear;
            case 'profile':
                return user;
            default:
                return moon;
        }
    }

    const getColor = () => {
        switch (type) {
            case 'default':
                return 'bg-[#60637A]';
            case 'light':
                return 'bg-[#C5C5E2]';
            case 'dark':
                return 'bg-[#7F7F7F]';
            default:
                return 'bg-[#C5C5E2]';
        }
    }

    const getTextColor = () => {
        switch (type) {
            case 'default':
                return 'text-white';
            case 'light':
                return 'text-[#60637A]';
            case 'dark':
                return 'text-white';
            default:
                return 'text-[#60637A]';
        }
    }

    const renderBookDescription = () => {
        if (text && isExpanded) {
            return (
                <span>{text}{text.length > 500 ? <span className='underline cursor-pointer' onClick={() => setIsExpanded(false)}>Read less.</span> : ''}</span>
            )
        } else if (text && !isExpanded) {
                return (<span>{text.slice(0, 500)} {text.length > 500 ? <span className='underline cursor-pointer' onClick={() => setIsExpanded(true)}>{' '}Read more.</span> : ''}</span>)
        }
    }


  useEffect(() => {
    // Check of scherm breed genoeg is (bijvoorbeeld 1024px voor desktop)
    const mediaQuery = window.matchMedia('(min-width: 1024px)');

    // functie om state te updaten
    const handleMediaChange = (e:any) => {
      if (e.matches) {
        setOpen(true);  // desktop: altijd open
      } else {
        setOpen(false); // mobiel: standaard dicht
      }
    };

    // init check
    handleMediaChange(mediaQuery);

    // listener toevoegen om te reageren op viewport changes
    mediaQuery.addEventListener('change', handleMediaChange);

    // cleanup
    return () => mediaQuery.removeEventListener('change', handleMediaChange);
  }, []);


    return (
        <div>
             <NavBar setOpen={setOpen} open={open}/>
             <SideBar setOpen={setOpen} open={open}/>
            <div className="page-layout md:ml-[200px] ml-0]">
                <div className={`header-card ${getColor()} rounded-3xl min-h-[100px]`}>
                    <div>
                    <div className='flex gap-4'>
                        {image && <img src={image} alt="logo" className='w-32 h-48 rounded-lg object-cover' />}
                        <div>
                            {headerText && <h1 className={`text-3xl ${getTextColor()} font-bold`}>{headerText}</h1>}
                            {underText && <h1 className={`text-xl italic  ${getTextColor()}`}>{underText}</h1>}
                            {text && <p className={`text-sm mt-3 hidden md:block ${getTextColor()}`}>{renderBookDescription()}</p>}
                        </div>
                        
                    </div>
                    
                    {text && <p className={`text-sm mt-3 md:hidden ${getTextColor()}`}>{renderBookDescription()}</p>}
                    </div>
                    <img src={getImage()} alt="moon" width={'150px'} className='hidden md:block max-h-[150px] object-contain' />
                </div>
                <div className="ml-[40px] mr-[40px]">
                    {children}
                </div>
            </div>
        </div>
        
    );
}

export default PageLayout;